module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kb0zq"))).then(() => parcelRequire('cvs7o'));